import React from "react";
import { exportVisitReport } from "../../helpers/ExportVisitReport";
import xlsIcon from "../../../../assets/icons/xlsIcon.svg";

export const DownloadSection = ({ data }) => {
  return (
    <div className="flex flex-col items-center justify-center border-2 border-dashed rounded-xl h-80">
      <div className="text-5xl mb-3">📊</div>

      <h3 className="font-semibold lg:text-lg">Download Visit Report</h3>

      <p className="text-gray-500 text-xs lg:text-sm mt-2 mb-5">
        Excel file containing all visit records.
      </p>

      <button
        onClick={async () => {
          await exportVisitReport(data);
        }}
        className="ml-1 text-sm flex gap-1 items-center justify-between border-1 py-1 bg-[#00800014] transition-all hover:bg-emerald-50 text-emerald-700 border-emerald-600 rounded-md px-3 font-figtreeMedium"
      >
        <img src={xlsIcon} alt="xls" className="w-4 h-4" />
        Download
      </button>
    </div>
  );
};
